import { webToast } from "@/assets/js/alertPopShow";
import loading from "@/components/loading"
import axios from 'axios'
import $ from 'jquery'
export default {
  components:{
    loading
  },
  wxjssdk(url){
    var that = this;
    // var url = window.location.href.split('#')[0];
    var formData2 = new FormData();
    formData2.append('url',encodeURIComponent(url));
    that.postData('/mhome.php/Index/getJssdk',formData2
      ,result =>{
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: result.content.appId, // 必填，公众号的唯一标识
          timestamp: result.content.timestamp, // 必填，生成签名的时间戳
          nonceStr: result.content.nonceStr, // 必填，生成签名的随机串
          signature: result.content.signature,// 必填，签名
          jsApiList: [
            'updateTimelineShareData',//1.4.0的分享接口，注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
            'updateAppMessageShareData',//1.4.0的分享接口,注意：使用新版本的分享功能，一定要在该列表加上对应的老版本功能接口，否则新接口不起作用
            'onMenuShareAppMessage',//老版本分享接口。
            'onMenuShareTimeline',//老版本分享接口。
            'scanQRCode'//微信扫一扫接口。
          ] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData({
            title: '理捷管理系统', // 分享标题
             // desc: 'TOPLIA拓利亚微官网', // 分享描述
            link: 'http://ljmes.ayunlian.com/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://ljmes.ayunlian.com/static/logo.png', // 分享图标
            success: function () {
              // 设置成功
            }
          })
          // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: '理捷管理系统', // 分享标题
            link: 'http://ljmes.ayunlian.com/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://ljmes.ayunlian.com/static/logo.png', // 分享图标
            success: function () {
              // 设置成功
            }
          })
        })
      })
  },
  // axios
  postData(url,data,success,complate){
    var that = this;
    var address = 'http://ljmes.ayunlian.com';
    axios({
      url: address + url,
      method:'post',
      data:data
    })
      .then(function (res) {
        if(res.data.status == 200){
          success && success(res.data);
        }
        if( res.data.status == 404 ){
          webToast(res.data.message,'middle',1500);
        }
        if( res.data.status == 502 ){
          webToast(res.data.message,'middle',1500);
          localStorage.removeItem('token');
          var goLogin = setTimeout(function () {
            window.location.href = '/login';
          },1500)
        }
        if( res.data.status == 503 ){
          success && success(res.data);
          // webToast(res.data.message,'middle',1500);
        }
      })
      .finally(function () {
        // always executed
        complate && complate();
      });
  },
  // 返回上一页
  returnPage(){
    var that = this;
    that.$router.go(-1);
  },
  hideSuccess(val,callback){
    var hideSuccess = setTimeout(function () {
      val = false;
      console.log('123');
      callback && callBack()
    },1500)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js